import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ClientsStrip from './components/ClientsStrip';
import ValueSection from './components/ValueSection';
import AudienceSection from './components/AudienceSection';
import ProblemSection from './components/ProblemSection';
import ServicesPreview from './components/ServicesPreview';
import CasesPreview from './components/CasesPreview';
import ProcessPreview from './components/ProcessPreview';
import TestimonialsSection from './components/TestimonialsSection';
import FaqPreview from './components/FaqPreview';
import CtaSection from './components/CtaSection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <ClientsStrip />
        <ValueSection />
        <AudienceSection />
        <ProblemSection />
        <ServicesPreview />
        <CasesPreview />
        <ProcessPreview />
        <TestimonialsSection />
        <FaqPreview />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
